var map = {
	"./en-US.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/en-US.po",
		29
	],
	"./ko-KR.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/ko-KR.po",
		30
	],
	"./tl-PH.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/tl-PH.po",
		31
	],
	"./tr-TR.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/tr-TR.po",
		32
	],
	"./vi-VN.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/vi-VN.po",
		33
	],
	"./zh-CN.po": [
		"./node_modules/@lingui/loader/index.js!./src/locales/zh-CN.po",
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/locales lazy recursive ./node_modules/@lingui/loader/index.js!./ ^\\.\\/.*\\.po$";
module.exports = webpackAsyncContext;